import { EnumOperationType } from '../../../../../enum/EnumOperationType';
import { useTranslation } from '../../../../../hooks';
import { displayAmountCurrying, toDisplayTime } from '../../../../../utils';
import { TransactionOperation } from '../../types/GetListRes';
import {
  TransactionOperationTableColumnKey,
  TransactionOperationTableRow,
} from '../types/TransactionOperationTable';

interface UseTableRowsProps {
  apiList: TransactionOperation[];
}

type ConvertToTableRowsType = (apiList: TransactionOperation[]) => TransactionOperationTableRow[];

const formatDate = (date: Date | string | number) => {
  if (!date) return '';

  return toDisplayTime(date as any);
};

const useTransactionOperationTableRows = (props: UseTableRowsProps) => {
  const { apiList } = props;
  const { t, translate } = useTranslation('enumConstants');

  const convertToTableRows: ConvertToTableRowsType = (apiList) => {
    if (!apiList) return [];

    const tableRows = apiList?.map((row, index): TransactionOperationTableRow => {
      const toDisplayAmount = displayAmountCurrying(row.decimals || 0);

      return {
        id: index,
        [TransactionOperationTableColumnKey.BatchID]: String(row.batchId),
        [TransactionOperationTableColumnKey.OperationSequence]: String(row.operationSeq),
        [TransactionOperationTableColumnKey.MerchantOrderID]: String(row.merchantOrderId),
        [TransactionOperationTableColumnKey.Version]: String(row.walletVersion),
        [TransactionOperationTableColumnKey.Path]: String(row.walletPath),
        [TransactionOperationTableColumnKey.OperationType]: translate(
          `EnumOperationType.${EnumOperationType[row.operationType]}`
        ),
        [TransactionOperationTableColumnKey.SendingAddress]: String(row.fromAddress),
        [TransactionOperationTableColumnKey.ReceivingAddress]: String(row.toAddress),
        [TransactionOperationTableColumnKey.WalletTagOfReceivingAddress]: String(
          row.toWalletTag || ''
        ),
        [TransactionOperationTableColumnKey.Amount]: `${toDisplayAmount(row.amount)} ${String(
          row.assetName
        )}`,
        [TransactionOperationTableColumnKey.CreationTime]: formatDate(row.createdDate),
        [TransactionOperationTableColumnKey.LastModifiedTime]: formatDate(row.lastModifiedDate),
        rawData: row,
      };
    });

    return tableRows;
  };

  const rows = convertToTableRows(apiList)?.sort((a, b) => {
    // sort by operation sequence in ascending order
    const operationSeqA = Number(a[TransactionOperationTableColumnKey.OperationSequence]);
    const operationSeqB = Number(b[TransactionOperationTableColumnKey.OperationSequence]);

    return operationSeqA - operationSeqB;
  });

  return { rows, totalCounts: apiList?.length || 0, convertToTableRows };
};

export default useTransactionOperationTableRows;
